'use client';

import CookieConsent from 'react-cookie-consent';

export default function CookieBanner() {
  return (
    <CookieConsent
      location="bottom"
      buttonText="Accept"
      declineButtonText="Decline"
      enableDeclineButton
      disableStyles={true}
      containerClasses="fixed right-[80px] bg-white text-black w-full max-w-xl shadow-lg rounded-lg p-6 z-[9999999999]"
      contentClasses="text-sm leading-relaxed"
      buttonWrapperClasses="flex justify-center gap-4 mt-4"
      buttonClasses="bg-black text-white text-sm font-semibold px-6 py-2 rounded-md hover:opacity-90 transition"
      declineButtonClasses="border border-black text-black bg-white text-sm font-semibold px-6 py-2 rounded-md hover:bg-gray-100 transition"
      expires={150}
    >
      We use essential cookies to make our site work. With your consent, we may also use non-essential cookies to improve user experience and analyze website traffic. By clicking “Accept,” you agree to our website's cookie use as described in our{' '}
      <a href="/cookie-policy" target="_blank" className="underline hover:text-blue-600">Cookie Policy</a>.
    </CookieConsent>
  );
}
